import { render, staticRenderFns } from "./FormBase.vue?vue&type=template&id=3203895a&scoped=true"
import script from "./FormBase.vue?vue&type=script&lang=js"
export * from "./FormBase.vue?vue&type=script&lang=js"
import style0 from "./FormBase.vue?vue&type=style&index=0&id=3203895a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3203895a",
  null
  
)

export default component.exports